import { render, staticRenderFns } from "./Tag2.vue?vue&type=template&id=5cd6b699&scoped=true"
import script from "./Tag2.vue?vue&type=script&lang=js"
export * from "./Tag2.vue?vue&type=script&lang=js"
import style0 from "./Tag2.vue?vue&type=style&index=0&id=5cd6b699&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6b699",
  null
  
)

export default component.exports